/**
 * @generated SignedSource<<90dbf80995442203da03e573f4b17455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertClassExitSlipInput = {
  classExitSlipInputs: ReadonlyArray<ClassExitSlipInput>;
};
export type ClassExitSlipInput = {
  classId: string;
  curriculumLessonId: string;
  dueOn: any;
  id?: string | null | undefined;
};
export type ExitSlipUpsertClassExitSlipMutation$variables = {
  input: UpsertClassExitSlipInput;
};
export type ExitSlipUpsertClassExitSlipMutation$data = {
  readonly upsertClassExitSlip: {
    readonly classExitSlipNode: ReadonlyArray<{
      readonly curriculumLesson: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly number: string | null | undefined;
      } | null | undefined;
      readonly dueOn: any;
      readonly id: string;
    }> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null | undefined;
  };
};
export type ExitSlipUpsertClassExitSlipMutation = {
  response: ExitSlipUpsertClassExitSlipMutation$data;
  variables: ExitSlipUpsertClassExitSlipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassExitSlipNode",
  "kind": "LinkedField",
  "name": "classExitSlipNode",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CurriculumLessonNode",
      "kind": "LinkedField",
      "name": "curriculumLesson",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnauthorizedAccessError",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "InvalidIdsError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipUpsertClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "upsertClassExitSlip",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipUpsertClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "upsertClassExitSlip",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5c4284635bbd0ecf4d25857645e0115",
    "id": null,
    "metadata": {},
    "name": "ExitSlipUpsertClassExitSlipMutation",
    "operationKind": "mutation",
    "text": "mutation ExitSlipUpsertClassExitSlipMutation(\n  $input: UpsertClassExitSlipInput!\n) {\n  upsertClassExitSlip(input: $input) {\n    classExitSlipNode {\n      id\n      curriculumLesson {\n        id\n        number\n        name\n      }\n      dueOn\n    }\n    errors {\n      __typename\n      ... on UnauthorizedAccessError {\n        message\n      }\n      ... on InvalidIdsError {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0b908f721d60b8590ee06a79869d19a";

export default node;
